import InputGroupRadioButton from './InputGroupRadioButton';

export default InputGroupRadioButton;
